var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71511 17.0966C1.96864 19.3585 3.80711 21.1544 6.08053 21.2638C7.65189 21.3395 9.25707 21.3789 10.9992 21.3789C12.7414 21.3789 14.3466 21.3395 15.9179 21.2638C18.1913 21.1544 20.0298 19.3585 20.2833 17.0966C20.4541 15.5734 20.5942 14.0117 20.5942 12.4209C20.5942 10.83 20.4541 9.26839 20.2833 7.74519C20.0298 5.4833 18.1913 3.6874 15.9179 3.5779C14.3466 3.50222 12.7414 3.46289 10.9992 3.46289C9.25708 3.46289 7.65189 3.50222 6.08053 3.5779C3.80711 3.6874 1.96864 5.4833 1.71511 7.74519C1.54437 9.26839 1.4043 10.83 1.4043 12.4209C1.4043 14.0117 1.54437 15.5734 1.71511 17.0966Z",
    fill: "#0A0C13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46875 1.77734L7.46875 5.91527",
    stroke: "#84C70D",
    strokeWidth: 2.35714,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5195 1.77734L14.5195 5.91527",
    stroke: "#84C70D",
    strokeWidth: 2.35714,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 11.3203L2.09184 11.3203L2.3419 4.74512L10.894 4.10187L19.9063 4.74512L19.9062 11.3203Z",
    fill: "#E6F4CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71511 17.0966C1.96864 19.3585 3.80711 21.1544 6.08053 21.2638C7.65189 21.3395 9.25707 21.3789 10.9992 21.3789C12.7414 21.3789 14.3466 21.3395 15.9179 21.2638C18.1913 21.1544 20.0298 19.3585 20.2833 17.0966C20.4541 15.5734 20.5942 14.0117 20.5942 12.4209C20.5942 10.83 20.4541 9.26839 20.2833 7.74519C20.0298 5.4833 18.1913 3.6874 15.9179 3.5779C14.3466 3.50222 12.7414 3.46289 10.9992 3.46289C9.25708 3.46289 7.65189 3.50222 6.08053 3.5779C3.80711 3.6874 1.96864 5.4833 1.71511 7.74519C1.54437 9.26839 1.4043 10.83 1.4043 12.4209C1.4043 14.0117 1.54437 15.5734 1.71511 17.0966Z",
    stroke: "#84C70D",
    strokeWidth: 2.35714
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86523 10.3379H20.2313",
    stroke: "#84C70D",
    strokeWidth: 2.35714
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenda);
export default __webpack_public_path__ + "static/media/calenda.ad43961d1c240fe7714958049255ec2a.svg";
export { ForwardRef as ReactComponent };